/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface AdminInviteUserResponse
 */
export interface AdminInviteUserResponse {
    /**
     * 
     */
    user: User;
}

/**
 * Check if a given object implements the AdminInviteUserResponse interface.
 */
export function instanceOfAdminInviteUserResponse(value: object): value is AdminInviteUserResponse {
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function AdminInviteUserResponseFromJSON(json: any): AdminInviteUserResponse {
    return AdminInviteUserResponseFromJSONTyped(json, false);
}

export function AdminInviteUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminInviteUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
    };
}

export function AdminInviteUserResponseToJSON(json: any): AdminInviteUserResponse {
    return AdminInviteUserResponseToJSONTyped(json, false);
}

export function AdminInviteUserResponseToJSONTyped(value?: AdminInviteUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserToJSON(value['user']),
    };
}

